/**
 * Changelog Modal Component
 *
 * Displays version history and changes in a modal overlay.
 * Uses i18n for translated content.
 */

import React from 'react';
import { useTranslation } from '../i18n/index.js';
import { VERSION } from '../version.js';
import './ChangelogModal.css';

export default function ChangelogModal({ onClose }) {
  const { t } = useTranslation();

  // Close on overlay click (but not modal content click)
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  // Get changelog entries from translations
  const changelogEntries = [
    { version: '0.15', changes: t('changelog.v0_15') },
    { version: '0.14', changes: t('changelog.v0_14') },
    { version: '0.13', changes: t('changelog.v0_13') },
    { version: '0.12', changes: t('changelog.v0_12') },
    { version: '0.11', changes: t('changelog.v0_11') },
    { version: '0.10', changes: t('changelog.v0_10') },
    { version: '0.9', changes: t('changelog.v0_9') },
    { version: '0.8', changes: t('changelog.v0_8') },
  ];

  return (
    <div className="changelog-modal-overlay" onClick={handleOverlayClick}>
      <div className="changelog-modal">
        <button className="changelog-close-btn" onClick={onClose} aria-label={t('changelog.close')}>
          &times;
        </button>

        <h2>{t('changelog.title')}</h2>
        <p className="changelog-current">v{VERSION}</p>
        <a
          href="https://git.soundworker.de/jakob/waterloo"
          target="_blank"
          rel="noopener noreferrer"
          className="source-code-btn"
        >
          {t('attributions.showSourceCode')} ↗
        </a>

        <div className="changelog-content">
          {changelogEntries.map((entry) => (
            <div key={entry.version} className="changelog-version">
              <h3>v{entry.version}</h3>
              <p>{entry.changes}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
